import { render } from "./SimpleInputV2.vue?vue&type=template&id=07acdc78&scoped=true&ts=true"
import script from "./SimpleInputV2.vue?vue&type=script&lang=ts"
export * from "./SimpleInputV2.vue?vue&type=script&lang=ts"

import "./SimpleInputV2.vue?vue&type=style&index=0&id=07acdc78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07acdc78"]])

export default __exports__